"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParkingSystem = exports.CarParkType = exports.CarParkOwner = void 0;
var CarParkOwner;
(function (CarParkOwner) {
    CarParkOwner["HDB"] = "HDB";
    CarParkOwner["URA"] = "URA";
})(CarParkOwner || (exports.CarParkOwner = CarParkOwner = {}));
var CarParkType;
(function (CarParkType) {
    CarParkType["BASEMENT"] = "BASEMENT CAR PARK";
    CarParkType["COVERED"] = "COVERED CAR PARK";
    CarParkType["MECHANISED"] = "MECHANISED CAR PARK";
    CarParkType["MECHANISED_AND_SURFACE"] = "MECHANISED AND SURFACE CAR PARK";
    CarParkType["MULTISTOREY"] = "MULTI-STOREY CAR PARK";
    CarParkType["SURFACE"] = "SURFACE CAR PARK";
    CarParkType["SURFACE_MULTISTOREY"] = "SURFACE/MULTI-STOREY CAR PARK";
})(CarParkType || (exports.CarParkType = CarParkType = {}));
var ParkingSystem;
(function (ParkingSystem) {
    ParkingSystem["COUPON"] = "COUPON PARKING";
    ParkingSystem["ELECTRONIC"] = "ELECTRONIC PARKING";
})(ParkingSystem || (exports.ParkingSystem = ParkingSystem = {}));
//# sourceMappingURL=types.js.map